import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Equipo } from '@domain/equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { Jugador } from '@domain/jugador';
import { CargadorTcPage, ResultadoTcPage } from '@pages';
import { App } from 'ionic-angular';
import { DesafioEquipoProvider } from '@providers/desafio-equipo/desafio-equipo';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';

@Component({
  selector: 'ronda-liberada',
  templateUrl: 'ronda-liberada.html'
})
export class RondaLiberadaComponent {

  @Input('equipo') equipo: Equipo;
  @Input('jugador') jugador: Jugador;
  @Input('estatus') estatus: EstatusRetosEquipo;
  ESTATUS_RETO_ENUM = EstatusRetoEnum;

  constructor(public app: App,
    public navCtrl: NavController,
    private desafioEquipoProvider: DesafioEquipoProvider) {
  }

  respondeRonda() {
    this.desafioEquipoProvider.estatus(this.equipo.area._id, this.equipo._id, this.jugador._id)
      .then( estatus => {
        this.estatus = estatus;
        if(this.estatus.estatus !== this.ESTATUS_RETO_ENUM.RESPONDER_RONDA) {
            return Promise.reject(this.estatus);
        }
        return this.desafioEquipoProvider.siguienteRonda(this.equipo.area._id, this.equipo._id, this.jugador._id);
      })
      .then( preguntas => {
        this.app.getRootNavs()[0].setRoot(CargadorTcPage, {
          equipo: this.equipo,
          preguntas: preguntas,
          jugador: this.jugador,
          estatus: this.estatus,
        });
      })
      .catch( e => {
        this.navCtrl.setRoot(ResultadoTcPage, {
          equipo: this.equipo,
          jugador: this.jugador
        })
      });
  }

}



// WEBPACK FOOTER //
// ./src/components/ronda-liberada/ronda-liberada.ts